import { render, staticRenderFns } from "./SpecimensComponent.vue?vue&type=template&id=10ce44f4"
import script from "./SpecimensComponent.vue?vue&type=script&lang=js"
export * from "./SpecimensComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports